import PubSub from "underpub-js";

var CalloutDualImage = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-CalloutDualImage',
	};

	$.extend(true, this.options, options);

};

CalloutDualImage.prototype.init = function() {

	var self = this;

};

export default CalloutDualImage;
